export default __webpack_public_path__ + "static/media/elevate-gry-3.e80263c0.png";